import { SessionExtra } from "../../store/Session/SessionModel";
import SkeletonLineWrapper from "../SkeletonWrapper/SkeletonLineWrapper";
import CombineSummaryChart from "./CombineSummaryChart";

interface Props {
  sessionData: SessionExtra;
}
const CombineSummaryWrap = ({ sessionData }: Props) => {
  const { drillTargets }: any = sessionData;
  if (!drillTargets || drillTargets?.length === 0) {
    return <p></p>;
  }
  return (
    <div className="combine-chart">
      <div className="wrap-combine-chart">
        <div className="text-wrapper-dispersion">Combine Summary</div>
        <SkeletonLineWrapper height="400px">
          <CombineSummaryChart sessionData={sessionData} />
        </SkeletonLineWrapper>
      </div>
    </div>
  );
};
export default CombineSummaryWrap;
